import * as yup from "yup";

export const metodoPagamentoSchema = yup.object().shape({
    metodoPagamento: yup.string().required('Método inválido')
});